var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"accordion"},[_vm._t("default",null,{"selected":_vm.selected,"select":_vm.select}),(_vm.bottomText)?_c('p',{staticClass:"bottom-text",domProps:{"innerHTML":_vm._s(_vm.bottomText)}}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }